import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { goBack } from 'connected-react-router';
import './BackButton.css';
import { useTranslation } from 'utils/modifiedTranslation';
import BackIcon from 'assets/icons/back.svg';

export const BackButton = ({ action }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <div
      className="back-button middle"
      onClick={action || (() => {
        dispatch(goBack());
      })}
    >
      <img alt="" src={BackIcon} />
      {' '}
      {t('trial.back')}
    </div>
  );
};

BackButton.propTypes = {
  action: PropTypes.func,
};
